(function (ng) {
    //directive that auto-selects an input's text when clicked

    ng.module('evo.Compare.Directives').directive('autoSelect',
        function () {
            return {
                link: function ($scope, $element) {
                    ng.element($element).click(function () {
                        ng.element(this).select();
                    });
                },
                restrict: 'A'
            };
        });
})(angular);